import { IResponse } from '@zmedia/bm-soccer-ui/interface';
import { getWithPath } from '@zmedia/bm-soccer-ui/utils/http';

const API_PATH = {
    GET_LIST: '/live/get',
    GET_MATCHES: '/live/get/matches',
    GET_STATS: '/live/get/stats',
    GET_EVENTS: '/live/get/events',
    GET_PEN_SHOOTOUT: '/live/get/penalties-shootout',
};

export const LiveService = {
    getList: (): Promise<IResponse<any>> => {
        return getWithPath(API_PATH.GET_LIST);
    },
    getMatches: (): Promise<IResponse<any>> => {
        return getWithPath(API_PATH.GET_MATCHES);
    },
    getStats: (id: number): Promise<IResponse<any>> => {
        return getWithPath(API_PATH.GET_STATS, { id });
    },
    getEvents: (id: number): Promise<IResponse<any>> => {
        return getWithPath(API_PATH.GET_EVENTS, { id });
    },
    getPenShootout: (id: number): Promise<IResponse<any>> => {
        return getWithPath(API_PATH.GET_PEN_SHOOTOUT, { id });
    },
};

export default LiveService;
